import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({
    endPoint: 'entity/FindAllCommercialSocietyTypeKeyValue',
    method: 'GET',
    body: null,
    token: token
  })
}
